export const MIN_ZOOM = 1;
export const MAX_ZOOM = 5;
export const DEFAULT_ASPECT_RATIO_SLUG = 'original';
